import ArticleToolbar from "@features/toolbar/ArticleToolbar/ArticleToolbar";
import ArticleByline from "@routes/Article/components/ArticleByline/ArticleByline";
import { FeedArticleData } from "@routes/Article/utils/types";

type PodcastArticleToolbarComponentProps = {
  /**  Article data for the podcast article */
  article: FeedArticleData;
  /**  Boolean indicating if the article is a premium article */
  isPremium?: boolean;
  /**  Function to handle gift url modal */
  handleGenerateGiftURLModal?: () => void;
  /**  Function to handle the gift modal button click */
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

/**
 * Component to display toolbar for podcast articles.
 * https://www.figma.com/design/xsbEGttNPBTNUi388qtSJD/PODCASTS--WEB-?node-id=4844-133403&m=dev
 */
const PodcastArticleToolbarComponent = ({
  article,
  setIsModalOpen,
  isPremium,
  handleGenerateGiftURLModal,
}: PodcastArticleToolbarComponentProps): React.ReactElement => {
  return (
    <div
      data-testid="podcast-article-toolbar-component"
      className="my-6 flex flex-col gap-2 md:mx-8 md:gap-3 lg:mx-8 lg:flex-row lg:items-center lg:justify-between lg:border-b lg:border-gray-175 lg:pb-4"
    >
      <ArticleByline
        authors={article.authors || []}
        editedTime={article.editedTime}
        updatedTime={article.publishTime}
        hasUpdatedTimeDisplayed={article.hasUpdatedTimeDisplayed}
        linkParams={new URLSearchParams({ ref: "article-top-byline" })}
      />

      <ArticleToolbar
        articleTitle={article.title}
        shareUrl={article.shortUrl || ""}
        isPremium={isPremium}
        handleGenerateGiftURLModal={handleGenerateGiftURLModal}
        setIsModalOpen={setIsModalOpen}
        keyword={article.tags}
        cueId={article.id}
        isSummaryAvailable={article.isSummaryAvailable}
        isPodcastArticleToolbar
        className="w-auto justify-start"
      />
    </div>
  );
};

export default PodcastArticleToolbarComponent;
